import { useState } from "react";
import { notifyError } from "src/assets/toastService";
import { summeryReport } from "src/shared/api";
import { errorHandling } from "src/shared/services/errorHandling";

function useSummeryReport() {
  const [summery, setSummery] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  const createReport = async (from: string, to: string, userId?: string) => {
    if (!from && !to) {
      notifyError("pls select From and To date");
      return;
    }

    try {
      setLoading(true);

      const res = await summeryReport(from, to, userId);
      console.log(res)
      setSummery(res.data);
      return res;
    } catch (error) {
      errorHandling(error);
      console.error("Summary report error:", error);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return {
    summery,
    loading,
    createReport,
  };
}

export default useSummeryReport;
